import { Button, Modal } from 'react-bootstrap';
import { useEffect, useState } from 'react';
import { fetchWrapper } from '../../../../../../../_helpers';
import { toast } from 'react-toastify';
import { IMAGESTYPES } from '../../../../../../../contants/enums';

function CategoryModal({ show, handleClose }) {
	const [title, setTitle] = useState('');
	const [pinImg, setPinImg] = useState();
	const [isPremium, setIsPremium] = useState(false);
	const [isManager, setIsManager] = useState(false);

	useEffect(() => {
		setTitle(show?.name);
		setIsPremium(show?.isPremium ? true : false);
	}, [show]);
	const handleCerateCategory = async () => {
		try {
			let formData = new FormData();
			formData.append('name', title);
			if (pinImg) {
				formData.append('pin', pinImg[0]);
			}
			formData.append('isPremium', isPremium);
			// formData.append('isManager', isManager);
			if (show?._id) {
				await fetchWrapper.put(`/pins/${show._id}`, formData, true);
			} else {
				await fetchWrapper.post(`/pins`, formData, true);
			}
			handleClose();
		} catch (err) {
			toast.error(err.message);
		}
	};
	return (
		<Modal show={Boolean(show)} onHide={handleClose} centered>
			<Modal.Header closeButton>
				<Modal.Title>
					{show?._id ? 'Edit ' : 'Create '}
					Category
				</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<div className="d-flex flex-column justify-content-between">
					<div>
						<label>
							Map Pin Image:
							<input
								type="file"
								accept={IMAGESTYPES}
								className="w-100"
								onChange={(e) => setPinImg(e.target.files)}
							/>
						</label>
					</div>
					<div>
						<label>
							Category Title:
							<input className="px-2 w-100" value={title} onChange={(e) => setTitle(e.target.value)} />
						</label>
					</div>
					<div className="mt-2">
						<label className="d-flex align-items-center">
							<div>Admin Category</div>
							:
							<input
								className="px-2 ml-3"
								type="checkbox"
								checked={isPremium}
								onChange={(e) => setIsPremium(e.target.checked)}
							/>
						</label>
					</div>
					{/* <div className="mt-2">
						<label className="d-flex align-items-center">
							<div>Manager Category</div>
							:
							<input
								className="px-2 ml-3"
								type="checkbox"
								checked={isManager}
								onChange={(e) => setIsManager(e.target.checked)}
							/>
						</label>
					</div> */}
				</div>
			</Modal.Body>
			<Modal.Footer className="justify-content-start">
				<Button className="ml-2" onClick={handleCerateCategory}>
					{show?._id ? 'Edit ' : 'Create '}
				</Button>
			</Modal.Footer>
		</Modal>
	);
}

export default CategoryModal;
